var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMslpCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2875 25.2699L26.8007 26.7755C26.7222 26.7237 25.235 25.7367 24.0859 25.515L26.5727 24.0094C27.7226 24.2319 29.2098 25.2189 29.2875 25.2708",
    fill: "#08091B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5274 17.3978L9.52742 17.3978C13.076 15.664 17.3955 16.0293 21.5425 18.1097C25.6866 20.1887 29.6136 23.9631 32.3165 28.9506C35.0197 33.9384 35.9682 39.1587 35.3435 43.5546C34.719 47.949 32.5329 51.4849 28.9902 53.2159C25.4416 54.9498 21.1221 54.5846 16.975 52.5042C12.8308 50.4252 8.90359 46.6506 6.20022 41.6623C3.49661 36.6736 2.54815 31.4535 3.17306 27.0581C3.79776 22.6642 5.98421 19.1288 9.5274 17.3978Z",
    fill: "url(#paint0_linear_11606_37194)",
    stroke: "url(#paint1_linear_11606_37194)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9555 43.0084L28.4688 44.514C28.5923 44.4416 28.7086 44.3576 28.8161 44.263L31.3029 42.7574C31.1955 42.8522 31.0792 42.9362 30.9555 43.0084Z",
    fill: "#027F5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2481 19.5182L8.76047 21.0238C8.73374 21.0372 8.71622 21.0472 8.70703 21.0531L11.1938 19.5475C11.203 19.5424 11.2205 19.5324 11.2481 19.519",
    fill: "#08091B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1938 19.5508L8.70703 21.0564L8.71288 21.0522L11.1996 19.5466H11.1938",
    fill: "#027F5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3032 43.0403L14.8164 44.5459C14.8859 44.5058 14.9521 44.4602 15.0143 44.4095L17.5019 42.9039C17.4391 42.9542 17.3727 42.9998 17.3032 43.0403",
    fill: "#027F5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.540894 26.6983L3.02851 25.1927V25.1918C3.87442 21.841 5.70234 19.0791 8.43964 17.4213L5.95286 18.9269C3.21306 20.5847 1.38763 23.3475 0.540894 26.6983ZM9.90849 47.715L9.90799 47.7153C8.28902 45.9578 6.89531 44.0048 5.75913 41.9017C2.63771 36.1427 1.80183 30.0501 3.02852 25.1937L0.540903 26.6993C-0.68495 31.5557 0.150931 37.6475 3.27235 43.4073C4.40836 45.5106 5.80227 47.4635 7.42171 49.2206L9.90799 47.7153L9.90802 47.7153L7.42169 49.2206C13.1334 55.3969 20.866 58.0317 26.7214 55.1719C27.0203 55.0236 27.309 54.8658 27.5873 54.6985L30.057 53.2038C29.7831 53.3692 29.5002 53.5231 29.2082 53.6655C23.3528 56.5261 15.6202 53.8905 9.90849 47.715Z",
    fill: "#305683"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11606_37194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.644 32.6947L12.5857 33.404C12.5859 33.4849 12.6217 33.6276 12.7306 33.7641C12.7307 33.7642 12.7305 33.764 12.7306 33.7641L19.4864 42.2202L25.0465 38.494L19.794 29.0306C19.794 29.0306 19.794 29.0306 19.794 29.0306C19.7096 28.8786 19.5906 28.7908 19.5154 28.7599L18.4575 29.4689L17.8393 29.3144C16.9358 29.0886 15.9776 29.2533 15.1825 29.7862C14.3874 30.319 13.8707 31.1427 13.7361 32.0642L13.644 32.6947ZM17.9457 44.9812C17.9402 44.9851 17.9345 44.9888 17.9287 44.9924C17.8812 45.0219 17.8274 45.0408 17.7699 45.0484C17.7053 45.0568 17.6374 45.0507 17.5699 45.0304C17.5024 45.0101 17.4368 44.976 17.3769 44.9301C17.3169 44.8842 17.2638 44.8275 17.2207 44.7631C17.1775 44.6987 17.1452 44.628 17.1255 44.5551C17.1058 44.4822 17.0992 44.4085 17.1061 44.3384C17.113 44.2683 17.1332 44.2031 17.1655 44.1466C17.1906 44.1029 17.2225 44.0651 17.2602 44.0345C17.2659 44.0298 17.2717 44.0253 17.2777 44.021C17.2832 44.017 17.2888 44.0132 17.2945 44.0095L18.4561 43.231L11.6084 34.6599C11.2995 34.2728 11.1326 33.79 11.1512 33.3345C11.1703 32.8776 11.3728 32.4883 11.7065 32.2647L12.3153 31.8567C12.509 30.5304 13.2537 29.3502 14.3831 28.5934C15.5125 27.8365 16.8871 27.5963 18.1875 27.9213L18.7962 27.5133C19.13 27.2897 19.5677 27.2509 19.9964 27.4067C20.425 27.5625 20.809 27.9006 21.0494 28.3337L26.3731 37.9253L27.5352 37.1465C27.5408 37.1426 27.5465 37.1388 27.5522 37.1353C27.5583 37.1315 27.5645 37.1279 27.5708 37.1244C27.6136 37.1011 27.6609 37.0859 27.7111 37.0793C27.7756 37.0708 27.8436 37.0769 27.911 37.0972C27.9785 37.1175 28.0441 37.1516 28.1041 37.1975C28.164 37.2434 28.2171 37.3002 28.2603 37.3646C28.3034 37.429 28.3358 37.4997 28.3554 37.5726C28.3751 37.6455 28.3817 37.7191 28.3748 37.7893C28.368 37.8594 28.3478 37.9246 28.3154 37.981C28.2866 38.0314 28.2486 38.0739 28.2033 38.1067C28.1978 38.1107 28.1921 38.1145 28.1864 38.1182L17.9457 44.9812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7599 30.9511L15.6559 31.6909L17.0269 33.7367L15.371 34.8465L16.285 36.2103L17.941 35.1005L20.226 38.5101L21.3299 37.7702L19.0449 34.3607L20.7009 33.2509L19.7869 31.8871L18.1309 32.9968L16.7599 30.9511Z",
    fill: "#03F5AE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_11606_37194)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9417,
    cy: 33.8896,
    rx: 11.6844,
    ry: 5.00758,
    transform: "rotate(53.1138 23.9417 33.8896)",
    fill: "black"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5074 8.7033L29.8812 10.3814C29.9632 10.3352 31.5166 9.45606 32.6785 9.31639L30.3046 7.63834C29.1419 7.77879 27.5885 8.65791 27.5073 8.70414",
    fill: "#08091B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7751 2.25137L47.7751 2.25136C44.3584 0.270395 40.0238 0.328676 35.7398 2.10997C31.4588 3.89006 27.2742 7.37671 24.2246 12.16C21.1747 16.9438 19.8587 22.0838 20.1703 26.5129C20.4818 30.9405 22.4118 34.6224 25.8229 36.6001C29.2397 38.5811 33.5743 38.523 37.8583 36.7417C42.1395 34.9616 46.3243 31.4748 49.3744 26.6907C52.4247 21.9061 53.7407 16.7663 53.4289 12.3377C53.1172 7.91053 51.1867 4.22914 47.7751 2.25137Z",
    fill: "url(#paint2_linear_11606_37194)",
    stroke: "url(#paint3_linear_11606_37194)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5837 26.2787L26.9575 27.9568C26.8395 27.8758 26.7294 27.7838 26.6288 27.6818L24.255 26.0038C24.3554 26.1059 24.4655 26.198 24.5837 26.2787Z",
    fill: "#027F5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9067 4.24424L48.2814 5.92235C48.3071 5.93759 48.3239 5.94884 48.3326 5.95533L45.9588 4.27728C45.95 4.27162 45.9332 4.26037 45.9067 4.24507",
    fill: "#08091B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9606 4.28076L48.3344 5.95881L48.3289 5.95422L45.9551 4.27617L45.9609 4.27659",
    fill: "#027F5A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2012 27.2782L40.575 28.9563C40.5085 28.9114 40.4458 28.8612 40.3873 28.8063L38.0126 27.1282C38.0717 27.1828 38.1348 27.2329 38.2012 27.2782",
    fill: "#027F5A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0765 12.1652L53.7018 10.4871L53.7019 10.4862C53.0955 7.08392 51.4679 4.19938 48.855 2.35172L51.2288 4.02978C53.8443 5.87761 55.4693 8.7628 56.0765 12.1652ZM45.243 32.4652L45.2435 32.4655C46.9829 30.8272 48.5115 28.9779 49.7939 26.9605C53.3156 21.4373 54.5812 15.4192 53.7017 10.488L56.0764 12.1662C56.955 17.0972 55.6895 23.1145 52.1677 28.6386C50.8855 30.6561 49.3567 32.5053 47.6168 34.1432L45.2435 32.4655L45.2434 32.4655L47.6168 34.1433C41.4817 39.8993 33.5819 41.9794 27.9439 38.7119C27.6562 38.5427 27.3795 38.3649 27.1137 38.1783L24.756 36.5122C25.0176 36.6966 25.2889 36.8702 25.5701 37.033C31.2081 40.3014 39.108 38.2204 45.243 32.4652Z",
    fill: "#305683"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11606_37194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2447 13.7575L36.2142 12.9959C36.1385 13.022 36.0151 13.1031 35.923 13.2521C35.923 13.2522 35.9231 13.252 35.923 13.2521L30.2436 22.467L35.6664 26.4747L42.8088 18.3413C42.8088 18.3413 42.8088 18.3413 42.8088 18.3413C42.9239 18.2102 42.9655 18.0676 42.9679 17.9872L41.9379 17.226L41.8735 16.5943C41.7788 15.6646 41.2958 14.812 40.5183 14.2374C39.7407 13.6628 38.784 13.4514 37.8675 13.6336L37.2447 13.7575ZM43.8878 19.2887L36.6491 27.5318L37.78 28.3676C37.7855 28.3716 37.7909 28.3756 37.7962 28.3798C37.8 28.3828 37.8037 28.3859 37.8073 28.389C37.8464 28.4225 37.8789 28.4637 37.9033 28.5111C37.9333 28.5692 37.9507 28.6354 37.9545 28.7059C37.9583 28.7764 37.9485 28.8498 37.9256 28.9218C37.9027 28.9938 37.8672 29.063 37.8212 29.1253C37.7751 29.1876 37.7194 29.2419 37.6573 29.2849C37.5952 29.3279 37.5279 29.3589 37.4594 29.3759C37.3909 29.3929 37.3225 29.3957 37.2582 29.3841C37.2008 29.3738 37.1476 29.3521 37.1012 29.3203C37.0956 29.3165 37.0902 29.3125 37.0848 29.3084L27.1189 21.9432C27.1134 21.9392 27.108 21.9352 27.1027 21.931C27.0586 21.8959 27.0223 21.8515 26.9956 21.7997C26.9656 21.7416 26.9482 21.6754 26.9444 21.6049C26.9406 21.5344 26.9504 21.461 26.9733 21.389C26.9962 21.317 27.0317 21.2478 27.0777 21.1855C27.1238 21.1232 27.1795 21.0689 27.2416 21.0259C27.3037 20.9829 27.371 20.9519 27.4395 20.9349C27.508 20.9179 27.5764 20.9151 27.6407 20.9267C27.6931 20.9361 27.7418 20.9549 27.7852 20.9823C27.7894 20.9849 27.7936 20.9877 27.7977 20.9905C27.8033 20.9943 27.8088 20.9983 27.8141 21.0024L28.9446 21.8379L34.7009 12.4983C34.9611 12.0768 35.3599 11.7574 35.7961 11.6221C36.2338 11.4869 36.6702 11.5474 36.995 11.7875L37.5874 12.2253C38.9051 11.9633 40.2726 12.2704 41.3717 13.0826C42.4708 13.8949 43.1658 15.112 43.302 16.4486L43.8945 16.8864C44.2192 17.1265 44.405 17.5267 44.4039 17.9836C44.4029 18.4405 44.2147 18.9165 43.8878 19.2887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9593 16.1203L38.8849 15.3263L37.4213 17.3068L35.8098 16.1158L34.834 17.4362L36.4455 18.6271L34.006 21.928L35.0804 22.7219L37.5198 19.4211L39.1314 20.6121L40.1071 19.2917L38.4956 18.1008L39.9593 16.1203Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11606_37194",
    x: 7.86328,
    y: 16.0701,
    width: 32.1562,
    height: 35.6392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_11606_37194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11606_37194",
    x1: 19.2582,
    y1: 15.7949,
    x2: 19.2582,
    y2: 54.8189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AC7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08429A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11606_37194",
    x1: 19.2582,
    y1: 15.7949,
    x2: 19.2582,
    y2: 54.8189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F76B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11606_37194",
    x1: 38.1824,
    y1: -0.0371547,
    x2: 35.4168,
    y2: 38.8888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AC7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08429A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11606_37194",
    x1: 38.1824,
    y1: -0.0371547,
    x2: 35.4168,
    y2: 38.8888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F76B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11606_37194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9474,
    height: 19.7013,
    fill: "white",
    transform: "translate(6.84375 31.6686) rotate(-33.8289)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11606_37194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0307,
    height: 19.7013,
    fill: "white",
    transform: "translate(35.9023 6.99841) rotate(36.4659)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMslpCoin);
export default __webpack_public_path__ + "static/media/mslp_coin.9434b7df215576d54e61af3921663d82.svg";
export { ForwardRef as ReactComponent };